import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=314b46db&scoped=true&"
import script from "./commonHeader.vue?vue&type=script&lang=js&"
export * from "./commonHeader.vue?vue&type=script&lang=js&"
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=314b46db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b46db",
  null
  
)

export default component.exports